import type { Runner } from '@ps/web-sports-api-types';
import { groupBy, mapKeys, sortBy, unzip } from 'lodash';

import type { Participants } from '@swf/sports/types/event';
import getParticipantAndScoresFromRunnerName from '@swf/sports/utils/getParticipantAndScoresFromRunnerName';

const getParticipantOrMathSign = (runner: Runner): string => {
  const { participant, homeScore, awayScore } = getParticipantAndScoresFromRunnerName(
    runner.runnerName
  );
  return participant ?? Math.sign(homeScore - awayScore).toString();
};

const transformRunnersToRows = (
  runners: Runner[],
  participants: Participants | undefined
): Runner[][] => {
  const { participant: participantFromRunner } = getParticipantAndScoresFromRunnerName(
    runners[0].runnerName
  );
  // if no participant in runner name, use home | draw | away
  const participantCols = participantFromRunner ? participants : ['1', '0', '-1'];

  // casing in event data and runner data can be different so convert to lower
  const groupedRunnersByColumns = mapKeys(
    groupBy(runners, getParticipantOrMathSign),
    (_runner, participantName) => participantName.toLowerCase()
  );

  return unzip(
    (participantCols ?? []).map((participant) =>
      sortBy(groupedRunnersByColumns[participant.toLowerCase()], ['sortPriority'])
    )
  );
};

export default transformRunnersToRows;
